import { ButtonBaseDefaultProps } from "./button-base";

export const defaultProps = () => ({
  ...ButtonBaseDefaultProps(),
});
